module.exports = __webpack_public_path__ + "img/0_bg.cb0d0917.png";